const floatParser = (
	num: number | string | undefined | null,
	defaultNum = 0): number => {
	if (typeof num === "number") num = num.toString();
	if (num === "") return 0;
	if (num === null || num === undefined || isNaN(parseFloat(num))) return defaultNum ?? 0;
	return parseFloat(num)
}

export default floatParser;